"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionContextManager = exports.SpecialRelIds = void 0;
const SessionStorageManager_1 = require("../../javascript/SessionStorageManager");
/**
 * Special values for RelIds.
 */
var SpecialRelIds;
(function (SpecialRelIds) {
    SpecialRelIds[SpecialRelIds["Undefined"] = 0] = "Undefined";
    SpecialRelIds[SpecialRelIds["All"] = 1] = "All";
})(SpecialRelIds = exports.SpecialRelIds || (exports.SpecialRelIds = {}));
/**
 * Managing selection Context
 */
class SelectionContextManager {
    constructor() {
        this.m_fullContext = {
            normalParentContext: {
                parentId: undefined,
                parentRelId: SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentId: undefined,
                parentRelId: SpecialRelIds.Undefined
            },
            selectedIds: [],
            parentControl: false,
            version: undefined
        };
    }
    /**
     * Get count of selected ids
     * @returns selection count
     */
    get SelCount() {
        return this.m_fullContext.selectedIds.length;
    }
    /**
     * Return selected ids
     * @returns selected ids
     */
    get SelectedIds() {
        return this.m_fullContext.selectedIds;
    }
    /**
    * Returns the full selection context.
    * @returns Full Selection Context
    */
    get FullSelectionContext() {
        return this.m_fullContext;
    }
    /**
     * Set and stores a new selectionContext
     * @param value New full Selection Context
     */
    set FullSelectionContext(value) {
        this.m_fullContext = value;
    }
    /**
    * Returns the selection context appropriate for the UseSelectedObjectAsContextInTree flag of a method and earlier selection
    * @param useSelectedObjectAsContextInTree UseSelectedObjectAsContextInTree flag
    * @returns Selection Context
    */
    getSelectionContextForMethod(useSelectedObjectAsContextInTree) {
        let parentContext = this.m_fullContext.normalParentContext;
        if (useSelectedObjectAsContextInTree && this.m_fullContext.parentControl)
            parentContext = this.m_fullContext.parentControlParentContext;
        return {
            selectedIds: this.m_fullContext.selectedIds,
            parentContext,
            version: this.m_fullContext.version
        };
    }
    // Methods for restoring and saving SelectionContext in Session-Storage from browser--------------------------------------------
    /**
     * Save Selection-Context by giving SessionStorageType
     * @param viewName Internal name of view for which to store selection context
     * @param fullSelectionContext Full selection context
     */
    saveSelectionContext(viewName, fullSelectionContext) {
        SessionStorageManager_1.SessionStorageManager.setItem(SessionStorageManager_1.SessionStorageType.SelectionContext_Restore, viewName, fullSelectionContext);
    }
    /**
     * Clear Selection-Context State for view
     * @param viewName Internal name of view for which to clear stored selection context
     */
    static clearSelectionStore(viewName) {
        SessionStorageManager_1.SessionStorageManager.removeSessionStorageType(SessionStorageManager_1.SessionStorageType.SelectionContext_Restore, viewName);
    }
    /**
     * Restore Selection-Context State for view
     * @param viewName Internal name of view for which to restore selection context
     */
    getStoredSelectionContext(viewName) {
        return SessionStorageManager_1.SessionStorageManager.getItem(SessionStorageManager_1.SessionStorageType.SelectionContext_Restore, viewName);
    }
}
exports.SelectionContextManager = SelectionContextManager;
